export const events = {
  accountclosed: "Account Closed",
  accounterased: "Account Erased",
  autopaycanceled: "Autopay Canceled",
  autopayscheduled: "Autopay Scheduled",
  autorenewcanceled: "Autorenew Canceled",
  autorenewresumed: "Autorenew Resumed",
  boomreportenrollmentfinished: "Boom Report Enrollment Finished",
  boomreportrefunded: "Boom Report Refunded",
  boomreporttradelineclosed: "Boom Report Tradeline Closed",
  boomreportunenrolledongoing: "Boom Report Unenrolled Ongoing",
  confirmedmovedoutdate: "Confirmed Moved Out Date",
  endingleaseupdatednewenddate: "Ending Lease Updated New End Date",
  endingleaseupdatedtomonthtomonth: "Ending Lease Updated To Month To Month",
  enrolled_renter_from_partner: "Enrolled Renter From Partner",
  failedresubscriptionpayment: "Failed Resubscription Payment",
  leaseisending: "Lease Is Ending",
  leasem2mwithunverifiedrentalverifications:
    "Lease M2M With Unverified Rental Verifications",
  payment_issues: "Payment Issues",
  paymentcanceled: "Payment Canceled",
  paymentedited: "Payment Edited",
  paymentmethodhasissue: "Payment Method Has Issue",
  paymentmethodupdated: "Payment Method Updated",
  paymentprocessing: "Payment Processing",
  paymentprocessing_dupe: "Payment Processing Dupe",
  paymentscheduled: "Payment Scheduled",
  payoutsending: "Payout Sending",
  plaid_connect_url_requested: "Plaid connect URL requested",
  plaid_identity_manual_verification_failed:
    "Plaid Identity Manual Verification Failed",
  plaid_identity_manual_verification_required:
    "Plaid Identity Manual Verification Required",
  plaid_identity_verification_finished: "Plaid Identity Verification Finished",
  refereeconverted: "Referee Converted",
  referraladded: "Referral Added",
  referralconverted: "Referral Converted",
  referralsignedup: "Referral Signed Up",
  registered: "Registered",
  rental_verification_uploaded_to_datalink:
    "Rental Verification Uploaded To Datalink",
  reportingaccountenrollmentapproved: "Reporting Account Enrollment Approved",
  reportingaccountenrollmentrejected: "Reporting Account Enrollment Rejected",
  reportingaccountenrollmentsubmitted: "Reporting Account Enrollment Submitted",
  reportingaccountenrollmentsubscribed:
    "Reporting Account Enrollment Subscribed",
  reportingaccountenrollmentsubscribed__ongoing:
    "Reporting Account Enrollment Subscribed Ongoing",
  reportingaccountenrollmentsubscribed__ongoingpast:
    "Reporting Account Enrollment Subscribed Ongoing Past",
  reportingaccountenrollmentsubscribed__past:
    "Reporting Account Enrollment Subscribed Past",
  resubscriptionsoonnotificationemail: "Resubscription Soon Notification Email",
  subscriptionexpired: "Subscription Expired",
  subscriptionrenewed: "Subscription Renewed",
  tradeline_support_submitted: "Tradeline Support Submitted",
  unverifiedrentalverificationrequires:
    "Unverified Rental Verification Requires",
  "upload-your-lease-email": "Upload Your Lease Email",
  verification_issues: "Verification Issues",
  optout_option_available: "Opt-out option available",
  opt_in_option_available: "Opt-in option available",
  identity_monitoring_opt_in_option_available:
    "Identity Monitoring Opt In Option Available",
  applicant_created: "Applicant Created",
  applicant_invited: "Applicant Invited",
  application_approved: "Application Approved",
  application_approved_with_conditions: "Application Approved With Conditions",
  application_rejected: "Application Rejected",
  application_decision_reverted: "Application Decision Reverted",
  boom_screen_individual_application_submitted:
    "Boom Screen Individual Application Submitted",
  boom_screen_group_application_submitted:
    "Boom Screen Group Application Submitted",
  "boom-screen-requested-pets-screening":
    "Boom Screen Requested Pets Screening",
  "invoiced-boomscreen-v1": "Invoiced BoomScreen V1",
  boom_report_customer_unenrolled_for_partner:
    "BoomReport Customer Unenrolled For Partner",
  credit_report_potential_fraud: "Credit Report Potential Fraud",
  credit_report_security_freeze: "Credit Report Security Freeze"
};

export const supportedFeatures = [
  "rent_reporting",
  "boom_screen",
  "bypass_bank_linking",
  "delinquency_reporting",
  "free_checkout",
  "free_ongoing",
  "free_past_reporting",
  "past_reporting_payout",
  "sdk",
  "boom_crm",
  "crm_listing_sync",
  "prescreening_idv",
  "skip_customer_identity_verification",
  "unexpired_enrollments_opt_in_period",
  "show_full_ssn",
  "plaid_shared_token",
  "trusted_kyc",
  "manual_invoicing",
  "pms_application_link_description",
  "allow_manual_property_management",
  "enable_credit_impact_dashboard",
  "enable_identity_theft_protection",
  "is_pms",
  "bypass_enrollment_verification_on_payment_through_portal_detected",
  "expires_sdk_authentication",
  "partner_pays_past_reporting",
  "skip_bank_linking",
  "pms_update_application_link",
  "pms_listing_sync",
  "bill_per_property",
  "bill_primitive_verifications_on_submit",
  "boom_report_managers_allowed",
  "combined_search_v2",
  "autoenroll_only_dob_or_ssn",
  "sites_and_communities",
  "property_group_market",
  "use_property_name_in_email",
  "single_sign_on",
  "use_property_name_in_submission_disclosure",
  "enterprise_propertyware",
  "include_pms_custom_fields",
  "include_pms_images",
  "use_propertyware_multimedia_scraper",
  "manual_application_property_manager_submission_disclosure",
  "ai_application_summary",
  "transunion_credit_report",
  "disallow_impersonate",
  "crm_feature_workflows",
  "crm_analytics",
  "home_site_rent",
  "enable_sdk_rent_reporting",
  "enable_sdk_credit_monitoring",
  "enable_sdk_identity_theft_protection",
  "template_fee_collection",
  "weekly_billing",
  "communication",
  "communication_sms",
  "provisioned_phone_number",
  "crm_ai_voice_agent",
  "use_slim_applications_api",
  "extended_bank_statements",
  "stripe_managed_billing",
  "auto_collect_invoices",
  "auto_send_payouts",
  "multiple_property_management_systems",
  "wip_feat_premium_rental_verification",
  "wip_boom_finance",
  "english_only",
  "wip_boom_finance",
  "inscribe_w2_verification"
];

export const featureRequirements = {
  sdk: null,
  rent_reporting: null,
  boom_screen: null,
  bypass_bank_linking: {
    or: ["sdk"]
  },
  delinquency_reporting: {
    or: ["rent_reporting"]
  },
  free_checkout: {
    or: ["sdk"]
  },
  free_ongoing: {
    or: ["sdk"]
  },
  past_reporting_payout: {
    or: ["sdk"]
  },
  skip_customer_identity_verification: null,
  unexpired_enrollments_opt_in_period: null,
  show_full_ssn: {
    or: ["rent_reporting", "boom_screen"]
  },
  plaid_shared_token: {
    or: ["sdk"]
  },
  trusted_kyc: null,
  manual_invoicing: null,
  pms_application_link_description: null,
  allow_manual_property_management: {
    or: ["rent_reporting", "boom_screen"]
  },
  enable_credit_impact_dashboard: {
    or: ["rent_reporting"]
  },
  enable_identity_theft_protection: {
    or: ["rent_reporting"]
  },
  is_pms: null,
  // TODO: not sure
  bypass_enrollment_verification_on_payment_through_portal_detected: null,
  expires_sdk_authentication: {
    or: ["sdk"]
  },
  skip_bank_linking: {
    or: ["sdk"]
  },
  pms_update_application_link: {
    and: ["boom_screen"]
  },
  // TODO: not sure
  bill_per_property: null,
  // TODO: not sure
  bill_primitive_verifications_on_submit: {
    or: ["boom_screen"]
  },
  boom_report_managers_allowed: null,
  combined_search_v2: {
    or: ["rent_reporting"]
  },
  autoenroll_only_dob_or_ssn: {
    or: ["rent_reporting"]
  },
  free_past_reporting: {
    or: ["sdk"]
  },
  partner_pays_past_reporting: {
    // TODO: add free checkout add     or: ["free_checkout", "free_past_reporting"],
    and: ["sdk", "api_access"]
  },
  sites_and_communities: {
    or: ["boom_screen"]
  },
  use_property_name_in_email: {
    or: ["boom_screen"]
  },
  prescreening_idv: {
    or: ["boom_crm"]
  },
  crm_listing_sync: {
    or: ["boom_crm"]
  },
  use_property_name_in_submission_disclosure: {
    or: ["boom_screen"]
  },
  manual_application_property_manager_submission_disclosure: {
    or: ["boom_screen"]
  },
  ai_application_summary: {
    or: ["boom_screen"]
  },
  transunion_credit_report: {
    or: ["boom_screen"]
  },
  disallow_impersonate: null,
  crm_feature_workflows: {
    or: ["boom_crm"]
  },
  crm_analytics: {
    or: ["boom_crm"]
  },
  home_site_rent: {
    or: ["boom_screen"]
  },
  enable_sdk_rent_reporting: {
    or: ["sdk"]
  },
  enable_sdk_credit_monitoring: {
    or: ["sdk"]
  },
  enable_sdk_identity_theft_protection: {
    or: ["sdk"]
  },
  template_fee_collection: {
    or: ["boom_screen"]
  },
  weekly_billing: null,
  communication: {
    or: ["boom_crm"]
  },
  communication_sms: {
    or: ["communication"]
  },
  provisioned_phone_number: {
    or: ["communication"]
  },
  crm_ai_voice_agent: {
    or: ["provisioned_phone_number"],
  },
  use_slim_applications_api: {
    or: ["boom_screen"]
  },
  extended_bank_statements: {
    or: ["boom_screen"]
  },
  stripe_managed_billing: null,
  auto_collect_invoices: null,
  auto_send_payouts: null,
  wip_feat_premium_rental_verification: {
    or: ["boom_screen"]
  },
  wip_boom_finance: {
    or: ["boom_screen"]
  },
  inscribe_w2_verification: {
    or: ["boom_screen"]
  },
};

// OneOf settings - mutually exclusive feature options
export const oneOfSettings = {
  primary_applicant_setting: {
    or: ["boom_screen"],
    title: "Primary applicant",
    defaultValue: "submitted_at",
    options: [
      {
        value: "submitted_at",
        label: "Use submitted_at for primary applicant",
        description:
          "Primary applicant: the applicant who submitted application first",
        feature: null // default, no feature flag needed
      },
      {
        value: "created_at",
        label: "Use created_at for primary applicant",
        description:
          "Primary applicant: the applicant who created application first",
        feature: "use_created_at_for_primary_applicant"
      }
    ]
  }
};

export const featureDescription = {
  api_access: "Access to the API, through api requests",
  rent_reporting: "Enables RentReporting on the portal",
  boom_screen: "Enables BoomScreen on the portal and applicant experience",
  boom_crm: "WIP: Do not enable this in Product",
  bypass_bank_linking: "SDK: plaid link issue flow with copy link",
  delinquency_reporting: "Report delinquency to credit bureaus for BoomReport",
  // Possibly not used.
  sdk: "Enables SDK",
  free_checkout:
    "SDK: free for customers. We change partner for past-reporting and monthly subscription. For control in SDK ui",
  free_ongoing:
    "SDK: Partner pays for monthly reporting in SDK, free for customers.",
  free_past_reporting: "SDK:Partner pays for past reporting product",
  // Requires api access
  partner_pays_past_reporting: "SDK: When partner enrolls customer from api",
  past_reporting_payout:
    "SDK: Customers pays us for past-reporting, we do payout to partners. (Rev share with partner)",
  skip_customer_identity_verification:
    "Landlord: Skip running whole identity after 7 day",
  unexpired_enrollments_opt_in_period:
    "Landlord: We don't have period to auto unenroll customers if they exceed opt-in period",
  show_full_ssn:
    "Allows partners to display full SSN on BoomScreen application reports when enabled for BoomScreen and in the Reporting page for BoomReport (instead of last 4)",
  plaid_shared_token:
    "SDK: plaid shared token flow. Flow where we close SDK and let host partner handle plaid through shared token flow",
  trusted_kyc:
    "Don't check for Identity Verification, we trust partners SSN and DOB. We assume partner already verified the identity",
  // only BoomReport
  is_pms: "When partner IS a PMS",

  bill_per_property:
    "BoomScreen AND BoomReport: Bill per property, each property may have different billing account",
  bill_primitive_verifications_on_submit:
    "BoomScreen: bill everything on submit, not per usage.",
  // TODO: ask Yunes
  boom_report_managers_allowed:
    "BoomReport: Managers allowed to manage properties",
  combined_search_v2: "Enable combined search v2 for BoomReport",
  autoenroll_only_dob_or_ssn:
    "BoomReport: Auto-enroll requires only DOB or SSN (not both)",
  // Any product and landlord included
  manual_invoicing: "We don't charge partner with our automated system",
  // Ask Marcos or Orest
  pms_application_link_description: "PMS: Application link description",
  // Marcos BOOMSCREEN
  allow_manual_property_management:
    "Partner can create property manually instead of sync",
  enable_credit_impact_dashboard: "Enable credit impact dashboard for partner",
  enable_identity_theft_protection:
    "Enable identity theft protection for partner's customers",
  // Ask Marcos
  pms_update_application_link: "PMS: Update application link",
  pms_listing_sync:
    "PMS: Sync listings data for listing experience from PMS like images, amenities, beds, baths, square feet, etc.",
  crm_listing_sync:
    "CRM: Enable listing sync for partners with BoomCRM. Controls whether units are synced to listings.",
  expires_sdk_authentication:
    "SDK: Expires SDK authentication and enables JWT flow",
  skip_bank_linking:
    "SDK: Skip bank linking for all flows. No plaid anywhere (partner build-in side or sdk side)",
  bypass_enrollment_verification_on_payment_through_portal_detected:
    "TODO:Ask somebody",
  sites_and_communities:
    "Renames units and properties to sites and communities for BSC and AX",
  use_property_name_in_email:
    "Use the property or community name in emails rather than the partner name",
  property_group_market:
    "Support 'Market' attribute for property groups. State attribute will no longer be available to use",
  single_sign_on: "Enable Single sign-on using WorkOS",
  prescreening_idv:
    "Enable partners to run an IDV as part of ‘pre-screening’, ahead of the entire rental application",
  use_property_name_in_submission_disclosure:
    "Use community or property name instead of partner name for the submission disclosure",
  enterprise_propertyware:
    "Enable Enterprise Propertyware partners to support multiple credentials / organizations",
  include_pms_custom_fields:
    "Enable partners to include custom fields in the PMS property / unit pull (propertyware specific for now)",
  include_pms_images:
    "Enable partners to include images in the PMS property / unit pull (propertyware specific for now)",
  use_propertyware_multimedia_scraper:
    "Enable propertyware multimedia scraper for partner",
  manual_application_property_manager_submission_disclosure:
    "[Only account managers should enable this feature] Proof of submission disclosure usage is required to use this feature. This enable partner users to self attest and sign manual application on behalf of applicant",
  ai_application_summary:
    "BETA: Enable Application Intelligence Summary for BoomScreen on applications/:id page",
  transunion_credit_report:
    "Add TransUnion as a new vendor option for credit reports",
  disallow_impersonate:
    "Prevents admin users from impersonating partner users for this partner",
  crm_feature_workflows: "Enable CRM feature workflows for partners",
  crm_analytics: "Enable CRM tab in Analytics for partner",
  home_site_rent: "Enable Home and Site Rent feature",
  enable_sdk_rent_reporting: "Enable rent reporting for SDK customers",
  enable_sdk_credit_monitoring: "Enable credit monitoring for SDK customers",
  enable_sdk_identity_theft_protection:
    "Enable identity theft protection for SDK customers",
  template_fee_collection:
    "Enable additional fees (administration fee, holding fee) collection during BoomScreen checkout",
  weekly_billing:
    "Allow partner to use weekly billing frequency instead of monthly",
  communication: "Enable communication features for partner",
  communication_sms: "Enable SMS provisioned phone numbers for partner",
  provisioned_phone_number: "Allow partners to buy and manage phone numbers from Twilio",
  crm_ai_voice_agent: "Enable AI voice agent (ElevenLabs) for partner's CRM. Requires a provisioned phone number.",
  use_slim_applications_api: "Use slim applications API for BoomScreen applications",
  extended_bank_statements: "Allow partners to request up to 6 months of bank statements instead of the default 3 months",
  stripe_managed_billing: "Enable Stripe managed billing for partner",
  auto_collect_invoices:
    "(Stripe only) Automatically collect invoices for partner via Stripe",
  auto_send_payouts:
    "(Stripe only) Automatically send payouts for partner via Stripe",
  // BF-294 stopgap: guidance-only warning, no front-end gating.
  multiple_property_management_systems:
    "Support multiple PMS integrations per partner. Only enable for NEW partners — enabling on a partner that already has a PMS can duplicate. Contact engineering to migrate existing partners.",
  wip_feat_premium_rental_verification:
    "WIP: Enable premium rental verification for BoomScreen applications",
  wip_boom_finance: "WIP: Enables Boom Finance configuration for partner",
  english_only: "Restrict the partner's portal to English only, hiding language selection controls",
  wip_boom_finance: "WIP: Enables Boom Finance configuration for partner",
  inscribe_w2_verification: "Enable Inscribe for W2 document verification"
};

export const featureCategories = {
  BoomScreen: [
    "boom_screen",
    "pms_update_application_link",
    "bill_primitive_verifications_on_submit",
    "sites_and_communities",
    "use_property_name_in_email",
    "use_property_name_in_submission_disclosure",
    "manual_application_property_manager_submission_disclosure",
    "ai_application_summary",
    "transunion_credit_report",
    "template_fee_collection",
    "home_site_rent",
    "use_slim_applications_api",
    "extended_bank_statements",
    "wip_feat_premium_rental_verification",
    "wip_boom_finance",
    "inscribe_w2_verification",
  ],
  "Rent Reporting": [
    "rent_reporting",
    "delinquency_reporting",
    "enable_credit_impact_dashboard",
    "enable_identity_theft_protection",
    "autoenroll_only_dob_or_ssn",
    "boom_report_managers_allowed",
    "combined_search_v2",
    "skip_customer_identity_verification",
    "trusted_kyc",
    "show_full_ssn",
    "unexpired_enrollments_opt_in_period",
    "sdk",
    "bypass_bank_linking",
    "free_checkout",
    "free_ongoing",
    "free_past_reporting",
    "past_reporting_payout",
    "partner_pays_past_reporting",
    "plaid_shared_token",
    "expires_sdk_authentication",
    "skip_bank_linking",
    "enable_sdk_rent_reporting",
    "enable_sdk_credit_monitoring",
    "enable_sdk_identity_theft_protection",
    "bypass_enrollment_verification_on_payment_through_portal_detected"
  ],
  BoomCRM: [
    "boom_crm",
    "crm_listing_sync",
    "prescreening_idv",
    "crm_feature_workflows",
    "pms_listing_sync",
    "communication",
    "provisioned_phone_number",
    "communication_sms",
    "crm_ai_voice_agent",
    "crm_analytics"
  ],
  "PMS Integration": [
    "is_pms",
    "pms_application_link_description",
    "enterprise_propertyware",
    "include_pms_custom_fields",
    "include_pms_images",
    "use_propertyware_multimedia_scraper",
    "property_group_market",
    "multiple_property_management_systems"
  ],
  Billing: [
    "manual_invoicing",
    "weekly_billing",
    "stripe_managed_billing",
    "auto_collect_invoices",
    "auto_send_payouts",
  ],
  General: [
    "allow_manual_property_management",
    "single_sign_on",
    "disallow_impersonate",
    "english_only",
  ],
};

export const propertiesManagementSystems = [
  "appfolio",
  "buildium",
  "entrata",
  "manage_america",
  "propertyware",
  "quext",
  "rent_manager",
  "rentvine",
  "resman",
  "revela",
  "yardi",
  "renters_warehouse"
];

export const partnerErrorMessages = {
  invalid_pms_amount: "PMS amount must be more than 0",
  invalid_settings_type: "Invalid settings format",
  invalid_pet_screening_url: "Invalid pet screening URL",
  boom_screen_requires_plaid_customer:
    "BoomScreen requires a Plaid customer to be created first"
};
